// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeOverlapType {
  ChargeOverlap = "CHARGE_OVERLAP",
  ExemptionOverlap = "EXEMPTION_OVERLAP",
}
export default ChargeOverlapType;
